import React from 'react';

interface GenerationProgressProps {
  stage: 'analyzing' | 'mapping' | 'generating' | 'building' | 'complete';
  progress: number;
  message?: string;
}

export const GenerationProgress: React.FC<GenerationProgressProps> = ({ stage, progress, message }) => {
  const stages = [
    { key: 'analyzing', label: 'Analyzing context', emoji: '🔍' },
    { key: 'mapping', label: 'Mapping principles', emoji: '🎯' },
    { key: 'generating', label: 'Generating injects', emoji: '⚡' },
    { key: 'building', label: 'Building facilitator notes', emoji: '📝' },
    { key: 'complete', label: 'Complete', emoji: '✅' }
  ];
  
  const currentStage = stages.find(s => s.key === stage) || stages[0];
  const currentStageIndex = stages.findIndex(s => s.key === stage);
  
  return (
    <div style={{ 
      padding: '20px',
      backgroundColor: 'white',
      borderRadius: '8px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      maxWidth: '400px',
      margin: '0 auto'
    }}>
      <div style={{ 
        display: 'flex',
        alignItems: 'center',
        marginBottom: '16px',
        fontSize: '16px',
        fontWeight: '600',
        color: '#2563eb'
      }}>
        <span style={{ marginRight: '8px' }}>{currentStage.emoji}</span>
        {currentStage.label}
      </div>
      
      {message && (
        <div style={{
          fontSize: '14px',
          color: '#6b7280',
          marginBottom: '16px'
        }}>
          {message}
        </div>
      )}
      
      <div style={{
        width: '100%',
        height: '8px',
        backgroundColor: '#e5e7eb',
        borderRadius: '4px',
        overflow: 'hidden',
        marginBottom: '12px'
      }}>
        <div style={{
          width: `${progress}%`,
          height: '100%',
          backgroundColor: '#2563eb',
          transition: 'width 0.3s ease',
          borderRadius: '4px'
        }} />
      </div>
      
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: '12px',
        color: '#6b7280'
      }}>
        {stages.map((stage, index) => (
          <div 
            key={stage.key}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              opacity: index <= currentStageIndex ? 1 : 0.4
            }}
          >
            <div style={{
              width: '20px',
              height: '20px',
              borderRadius: '50%',
              backgroundColor: index <= currentStageIndex ? '#2563eb' : '#e5e7eb',
              color: index <= currentStageIndex ? 'white' : '#6b7280',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '10px',
              marginBottom: '4px'
            }}>
              {index < currentStageIndex ? '✓' : index + 1}
            </div>
            <span style={{ fontSize: '10px', textAlign: 'center' }}>
              {stage.label.split(' ')[0]}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

